import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal3 } from "../DIsplay/Modal/Modal3";
import Button1 from "../form/Button1";
import { useInsuranceApi } from "../../hooks/useInsuranceApi";
import { setInsuranceOrders } from "../../redux/reducers/orderSlice";

export function ConfirmInsuranceIssuanceModal({
  open,
  setOpen,
  booking,
  onSuccess,
}) {
  const dispatch = useDispatch();
  const { insuranceOrders } = useSelector((state) => state.order);
  const { confirmInsuranceOrder } = useInsuranceApi();
  const [loading, setLoading] = useState(false);

  // console.log({ booking });

  const handleConfirm = async () => {
    await confirmInsuranceOrder({
      booking,
      setLoading,
      callbackUrl: (data) => {
        dispatch(
          setInsuranceOrders(
            insuranceOrders?.map((item) =>
              item?._id === data?._id ? data : item,
            ),
          ),
        );
        onSuccess?.(data);
        setOpen(false);
      },
    });
  };

  return (
    <Modal3 open={open} setOpen={setOpen} title="Confirm Insurance Issuance">
      <div className="max-w-[500px]">
        <div className="p-4">
          <p>
            Are you sure you want to issue this insurance ticket? This action
            cannot be undone.
          </p>
        </div>
        <div className="flex gap-4 p-4">
          <Button1 variant="text" type="button" onClick={() => setOpen(false)}>
            Cancel
          </Button1>
          <Button1 type="button" loading={loading} onClick={handleConfirm}>
            Confirm
          </Button1>
        </div>
      </div>
    </Modal3>
  );
}
